import { defaultTo } from 'ramda';
import { mapGiftServiceType } from './mapGiftServiceType';
import {
  EType,
  ISmartPackageGiftDtoV4,
} from '../../../../../repositories/billing-tariffs/entities/ServicePackages/SmartPackageGiftDtoV4';
import {
  ERecommendedPackageGiftType,
  ERecommendedPackagePublishType,
  TRecommendedPackageGift,
} from '../../../../../types/reducers/recommendedPackages';
import { getGiftServiceName } from './getGiftServiceName';

export const mapGift =
  (publishType: ERecommendedPackagePublishType) =>
  (gift: ISmartPackageGiftDtoV4): TRecommendedPackageGift => {
    if (gift.type === EType.Vas) {
      const { count, durationInDays } = gift;

      const serviceType = mapGiftServiceType(gift.serviceType!, publishType);

      return {
        type: ERecommendedPackageGiftType.Vas,
        name: getGiftServiceName(serviceType),
        serviceType,
        count: defaultTo(0, count),
        durationInDays: defaultTo(0, durationInDays),
      };
    } else {
      // type: 'cashback'
      const { auctionPoints, cashbackPercent } = gift;

      return {
        type: ERecommendedPackageGiftType.Cashback,
        name: 'Кешбэк',
        auctionPoints,
        cashbackPercent: cashbackPercent * 100,
      };
    }
  };
